import React, { useEffect, useRef } from 'react';
import { ProjectId, SpaceTabId } from 'api/models';
import { Loading } from 'components/atoms/loading';
import { useProjectDetail } from 'data/projects';
import { useSpaceTab } from 'data/space-tabs/hooks';
import { useSpaceTabHistoryLocalStorageState } from 'hooks/use-space-tab-local-storage-state';
import { SpaceTab } from './space-tab';
import { LoadingWrapper } from './styles';

interface SpaceTabContainerProps {
  spaceTabId: SpaceTabId<number>;
}
export const SpaceTabContainer = ({ spaceTabId }: SpaceTabContainerProps) => {
  const [_, projectId, spaceId, _spaceTabId] = spaceTabId;
  const { data, isLoading } = useSpaceTab(_spaceTabId);

  const { setValue } = useSpaceTabHistoryLocalStorageState();
  const setRecentSpaceValue = useRef(setValue);
  const project = useProjectDetail(ProjectId(projectId));

  useEffect(() => {
    setRecentSpaceValue.current?.(spaceId, _spaceTabId, projectId);
  }, [projectId, spaceId, _spaceTabId]);

  return isLoading ? (
    <LoadingWrapper>
      <Loading size="large" />
    </LoadingWrapper>
  ) : data && project.data ? (
    <SpaceTab data={data} project={project.data} />
  ) : null;
};
